import { useEffect } from 'react';

const EMBED_SCRIPT_SRC = 'https://insight.ascoat.com.au/js/embed.host.js';

export default function AnalyticsWidget() {
  // Loaded here (rather than a static <script> tag in index.html) so it only
  // runs once the iframe below is actually in the DOM -- React mounts it
  // asynchronously, so a script loaded eagerly in the document head could
  // race ahead of it.
  useEffect(() => {
    if (document.querySelector(`script[src="${EMBED_SCRIPT_SRC}"]`)) return;
    const script = document.createElement('script');
    script.src = EMBED_SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div className="card p-4">
      <iframe
        plausible-embed="true"
        src="https://insight.ascoat.com.au/share/ascoat.com.au?auth=RcGO0mmM1X9kWU6_O-qP9&embed=true&theme=system&background=transparent"
        scrolling="no"
        frameBorder="0"
        loading="lazy"
        title="Ascoat website analytics"
        style={{ width: '1px', minWidth: '100%', height: '1600px', colorScheme: 'auto' }}
      />
    </div>
  );
}
